import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  disconnect() {
    Modal.getInstance(this.element)?.hide()
  }
}
